import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPublicJobList } from "./publicJobListAPI";

const initialState = {
  data: [],
  total: 0,
  loading: false,
  error: null,
};

export const fetchPublicJobListAsync = createAsyncThunk(
  "JobList/fetch",
  async (page, { rejectWithValue }) => {
    try {
      const data = await fetchPublicJobList(page);  // Assuming this is your API call

      const resp = data?.response;  // Get the entire response object
      // console.log("resp", resp)
      if (!resp || !resp.data) {
        throw new Error("Invalid response structure");
      }

      // Return both the jobs data and the next page URL
      return {
        jobs: resp.data,  // The array of job data
        totalJobs: resp.total,  
      };
    } catch (error) {
      return rejectWithValue(error.message);  // Reject with the error message if something goes wrong
    }
  }
);


const PublicJobListSlice = createSlice({
  name: "PublicJobList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicJobListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicJobListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchPublicJobListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectPublicJobList = (state) => state.publicJobList.data.jobs;
export const selectPublicJobListTotal = (state) => state.publicJobList.data.totalJobs;

export default PublicJobListSlice.reducer;
